import { ReactNode, ComponentPropsWithoutRef } from "react";
import { cn } from "utils/cn";

interface PillButtonProps extends ComponentPropsWithoutRef<"button"> {
  variant?: "light" | "dark";
  onClick: () => void;
  label: JSX.Element | ReactNode | string,
  className?: string,
  outerDivClassName?: string,
};

const PillButton = ({ variant = "dark", onClick, label, className, outerDivClassName, ...buttonProps }: PillButtonProps) => {
  const buttonVariantStyles = {
    light: "FN-pill-button-light",
    dark: "FN-pill-button-dark",
  };
  
  return (
    <div className={cn(
      "rounded-[100px] p-1 bg-primary-white",
      // light variant on hover style
      variant === "light" ? "FN-pill-button-light-border-on-hover" : "",
      outerDivClassName,
    )}>
      <button 
        className={cn(
          "h-[36px] flex items-center justify-center rounded-[100px] min-w-[144px] font-semibold",
          buttonVariantStyles[variant],
          // dark variant on hover
          variant === "dark" ? "FN-pill-button-on-hover" : "",
          className,
        )}
        onClick={() => onClick()}
        { ...buttonProps }
      >
        {label}
      </button>
    </div>
  )
};

export default PillButton;